import gql from 'graphql-tag'

export const GET_PRODUCT_PARAMETERS = gql`
  query getProductByUrlKeyForDetailParameters($url: String!) {
    product: getProductByUrlKey(urlKey: $url) {
      id
      mainVariant {
        id
        parameters {
          key
          order
          title
          value
          paramValueId
          visible
          url
          description
          measure {
            description
            measureId
            title
          }
          groupId
        }
      }
    }
  }
`
